import React from "react";
import { Chip, Box, Stack } from "@mui/material";
import {
  Warning as WarningIcon,
  Flag as FlagIcon,
} from "@mui/icons-material";
import { useDispatch } from "react-redux";
import type { AppDispatch } from "../store";
import { openShipmentSidebar } from "../store/shipmentSlice";

interface ReminderCellProps {
  shipmentId: string;
  unresolvedExceptions: number;
  unresolvedMilestones: number;
}

export function ReminderCell({
  shipmentId,
  unresolvedExceptions,
  unresolvedMilestones,
}: ReminderCellProps) {
  const dispatch = useDispatch<AppDispatch>();

  const handleClick = (e: React.MouseEvent) => {
    // Stop event propagation to prevent row click
    e.stopPropagation();

    // Open shipment timeline sidebar
    dispatch(openShipmentSidebar({ shipmentId }));
  };

  // Only show chips if there are unresolved reminders
  if (unresolvedExceptions === 0 && unresolvedMilestones === 0) {
    return null;
  }

  return (
    <Box
      onClick={handleClick}
      sx={{
        cursor: "pointer",
        display: "inline-flex",
      }}
    >
      <Stack direction="row" spacing={0.5}>
        {/* Exception chip - orange warning icon */}
        {unresolvedExceptions > 0 && (
          <Chip
            icon={<WarningIcon />}
            label={unresolvedExceptions}
            size="small"
            sx={{
              fontSize: "0.75rem",
              height: "24px",
              backgroundColor: "#fff3e0",
              color: "#f57c00",
              border: "1px solid #ffa726",
              "& .MuiChip-icon": {
                fontSize: "16px",
                marginLeft: "6px",
                color: "#f57c00",
              },
              "&:hover": {
                backgroundColor: "#ffe0b2",
              },
            }}
          />
        )}

        {/* Milestone chip - green flag icon */}
        {unresolvedMilestones > 0 && (
          <Chip
            icon={<FlagIcon />}
            label={unresolvedMilestones}
            size="small"
            sx={{
              fontSize: "0.75rem",
              height: "24px",
              backgroundColor: "transparent",
              color: "#4caf50",
              border: "1px solid #4caf50",
              "& .MuiChip-icon": {
                fontSize: "16px",
                marginLeft: "6px",
                color: "#4caf50",
              },
              "&:hover": {
                backgroundColor: "rgba(76, 175, 80, 0.04)",
              },
            }}
          />
        )}
      </Stack>
    </Box>
  );
}
